import React from 'react';
import {
  LinkNameContainer,
  LinkContextMenu,
  ContextMenuIcon,
  NodeContainer,
  BottomBorder,
  LinkedNodes,
  LinkSurface,
  Container,
  LinkName,
  Row,
} from './style';
import { Column } from 'components/layout';
import NodePreview from 'components/node-preview';
import LinkRepresentation from 'components/canvas/components/side-drawer/components/drawer-link/components/link-representation';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import {
  useLinkMenuPositionOperation,
  useSelectedLinkOperations,
} from 'state/canvas/selected-link';
import { isUndefined } from 'lodash';
import { LinkSettings } from 'types';
import { SurfaceNodePointsTo, SurfaceNodeUnion } from 'graphql/types';
import { useNodeSearchParamsOperations } from 'routes/surface/hooks/use-node-search-params';
import { useSnippetSearchParamsOperations } from 'routes/surface/hooks/use-snippet-search-params';

export interface LinkProps {
  link: SurfaceNodePointsTo;
  node: SurfaceNodeUnion;
  linkNumber: number;
  removeGlobalLink: Function;
  closeDrawer: Function;
}

const defaultProps = {};

function DrawerLink({
  link,
  node,
  linkNumber,
  removeGlobalLink,
  closeDrawer,
}: LinkProps) {
  const { t } = useTranslation();
  const history = useHistory();
  const [linkMenuVisible, setLinkMenuVisible] = React.useState(false);
  const { setSelectedLink, clearSelectedLink } = useSelectedLinkOperations();
  const { clearLinkMenuPosition } = useLinkMenuPositionOperation();
  const [settings, setSettings] = React.useState<LinkSettings>(
    link.settings || {},
  );

  const { linkName, color } = settings;

  const { setNodeIdToSearchParams } = useNodeSearchParamsOperations();

  const { setSnippetIdToSearchParams } = useSnippetSearchParamsOperations();

  // @ts-ignore
  const containerNode = link.to?.containerNode as any;

  const parent = containerNode ?? link.to?.surface;

  const surfaceId = containerNode?.surface?.id ?? link.to?.surface?.id;

  function toggleLinkMenu() {
    setLinkMenuVisible(!linkMenuVisible);
    if (!linkMenuVisible) {
      clearLinkMenuPosition();
      return setSelectedLink(link);
    }

    clearSelectedLink();
  }

  function removeLink() {
    removeGlobalLink(link);
  }

  function navigateToParent() {
    closeDrawer();

    if (parent.__typename === 'SubSurfaceNode') {
      return history.push('/surface/' + parent.id);
    }

    closeDrawer();

    setNodeIdToSearchParams(parent.surface.id, parent.id);
  }

  function navigateToGlobalNode() {
    if (surfaceId) {
      const nodeId = containerNode?.id ?? link.to.id;

      closeDrawer();
      setNodeIdToSearchParams(surfaceId, nodeId);
      containerNode?.id && setSnippetIdToSearchParams(surfaceId, link.to.id);
    }
  }

  return (
    <Container>
      <LinkSurface
        onClick={navigateToParent}
        hidden={linkMenuVisible}
        parentType={parent.__typename}>
        {parent?.name}
      </LinkSurface>
      {linkMenuVisible && (
        <LinkContextMenu
          link={link}
          visible={linkMenuVisible}
          onDelete={removeLink}
          onChange={setSettings}
        />
      )}

      <Row spaceBetween>
        <Column>
          <LinkNameContainer>
            {t('Link {{index}} ', {
              replace: { index: linkNumber },
            })}
            {linkName && <LinkName color={color}>: {linkName}</LinkName>}
          </LinkNameContainer>
          <LinkedNodes>
            <span>{node.name}</span>
            <LinkRepresentation settings={settings} />
            <span>{link?.to?.name}</span>
          </LinkedNodes>
        </Column>
        <ContextMenuIcon onClick={toggleLinkMenu} />
      </Row>
      <NodeContainer
        onClick={navigateToGlobalNode}
        disabled={isUndefined(surfaceId)}>
        <NodePreview node={link.to} isSelected={false} />
      </NodeContainer>

      <BottomBorder />
    </Container>
  );
}

DrawerLink.defaultProps = defaultProps;

export default DrawerLink;
